import React, {useContext, useEffect, useState} from 'react'
import {AuthContext} from '../context/AuthContext'
import {MainContext} from '../context/MainContext'
import api from '../services/api'
import {DigitalWallet} from './digitalWallet'
import ClubCalendar from './ClubCalendar'
import HabitualitiesCard from './HabitualitiesCard'
import WeaponsCard from './WeaponsCard'
import MembersCard from './MembersCard'

export default function Home() {
    const { authUser } = useContext(AuthContext)
    const {setPageTitle, setLoading} = useContext(MainContext)
    const [ infos, setInfos ] = useState<any>({})


    useEffect(() => {
        setLoading(true)
        setPageTitle("Inicio")
        const fetchData = async () => {
            await getDataDashboard()
        };

         fetchData().then(()=>{
            setLoading(false)
         })
    }, []);

    async function getDataDashboard() {
        await api.post('/api/dashboard').then((response) => {
            setInfos(response.data)
        })
    }

    return (
        <section className="section dashboard">

            <div className="col-lg-12 mt-3">
                <div className="row align-items-stretch">
                    {(authUser?.role === 'athlete') &&
                    <div className="col-xxl-4 col-md-6">
                        <DigitalWallet/>
                    </div>
                    }

                    <div className="col-xxl-4 col-md-6">
                        <ClubCalendar />
                    </div>

                    <HabitualitiesCard habitualities={infos?.habitualities} shots={infos?.shots} />

                    {authUser?.role === 'athlete' &&
                        <WeaponsCard weapons={infos?.weapons} />
                    }

                    {['coordinator', 'admin'].includes(authUser?.role) &&
                        <MembersCard members={infos?.menbers} />
                    }

                </div>
            </div>

        </section>
    );
}
